const SPEED = 400; // px/s
const RIGHT_SCROLL_OFFSET = 0.8;
const LEFT_SCROLL_OFFSET = 0.2;
const RIGHT = "RIGHT",
  LEFT = "LEFT";

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

class ScrollPanner {
  constructor() {
    this.isDragging = false;
    this.startTime = null;
    this.request = null;
    this.MOVE_EVENT = isTouchDevice() ? "touchmove" : "mousemove";

    // ensure that this refers to the instance of ScrollPanner in the DOM event callbacks
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
  }
  initialize(taskDashboard) {
    if (!taskDashboard.$refs.taskDashboardRow) {
      throw "no ref called taskDashboardRow";
    }
    this.taskDashboardRow = taskDashboard.$refs.taskDashboardRow;

    let containers = taskDashboard.$children.filter(
      child =>
        child.$el.classList &&
        child.$el.classList.contains("smooth-dnd-container")
    );
    containers.forEach(container => {
      container.$on("drag-start", this.onDragStart);
      container.$on("drag-end", this.onDragEnd);
    });
  }
  startScrolling(direction) {
    const taskDashboardRow = this.taskDashboardRow;
    // this is because ideally we should scroll faster on larger screens
    let SCREEN_SIZE_ADJUSTMENT_FACTOR = taskDashboardRow.clientWidth / 1008;
    if (this.request === null) {
      this.request = window.requestAnimationFrame(timestamp => {
        if (this.startTime === null) {
          this.startTime = timestamp;
        }
        const timeDiff = timestamp - this.startTime;
        this.startTime = timestamp;
        let distanceDiff = (timeDiff / 1000) * SPEED;
        distanceDiff = direction === LEFT ? 0 - distanceDiff : distanceDiff;
        let distance = SCREEN_SIZE_ADJUSTMENT_FACTOR * distanceDiff;
        // keep the minimum scroll distance as 5
        if (Math.abs(distance) < 5) {
          distance = distance > 0 ? 5 : -5;
        }
        this.addScrollValue(taskDashboardRow, "x", distance);
        this.request = null;
        this.startScrolling(direction);
      });
    }
  }
  stopScrolling() {
    if (this.request !== null) {
      cancelAnimationFrame(this.request);
      this.request = null;
    }
    this.startTime = null;
  }
  onDragStart() {
    this.isDragging = true;
    this.taskDashboardRow.addEventListener(this.MOVE_EVENT, this.onMouseMove);
  }
  onMouseMove(event) {
    let clientRect = this.taskDashboardRow.getBoundingClientRect();
    // the scroll thresholds represent the extreme left and right portions the task dashboard
    // if the user drags the card into either of these portions, we start scrolling
    let rightScrollThreshold =
      (clientRect.right - clientRect.left) * RIGHT_SCROLL_OFFSET +
      clientRect.left;
    let leftScrollThreshold =
      (clientRect.right - clientRect.left) * LEFT_SCROLL_OFFSET +
      clientRect.left;
    let coordinates = this.getCoordinates(event);
    if (this.isDragging) {
      if (coordinates.x > rightScrollThreshold) {
        this.startScrolling(RIGHT);
      } else if (coordinates.x < leftScrollThreshold) {
        this.startScrolling(LEFT);
      } else {
        this.stopScrolling();
      }
    }
  }
  onDragEnd() {
    this.isDragging = false;
    // stop scrolling once the drag is complete
    this.stopScrolling();
    this.taskDashboardRow.removeEventListener(
      this.MOVE_EVENT,
      this.onMouseMove
    );
  }
  getCoordinates(event) {
    if (event instanceof window.TouchEvent) {
      return {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }
    return {
      x: event.x,
      y: event.y
    };
  }

  // utility function that scrolls a given element by a give value
  addScrollValue(element, axis, value) {
    if (element) {
      if (element !== window) {
        if (axis === "x") {
          element.scrollLeft += value;
        } else {
          element.scrollTop += value;
        }
      } else {
        if (axis === "x") {
          element.scrollBy(value, 0);
        } else {
          element.scrollBy(0, value);
        }
      }
    }
  }
}
export default ScrollPanner
